import axios from "axios";

export function isFileNameError(str: string) {
  // Detect for Non-ASCII or unsafe characters
  const ascii = /^[\u0000-\u007f]*$/;
  if (!ascii.test(str) && str != null && str != "") {
    return true
  } else {
    return false;
  }
};

export function isFileTypeError(fileType: string) {
  const videoMimeTypes = ["video/mp4"];
  const isError = !videoMimeTypes.includes(fileType);
  return isError;
};

export function isFileTooBigError(fileSize: number) {
  const fileMaxSize = 5368709120 * 1024;

  if (fileSize > fileMaxSize) {
    return true;

  } else {
    return false;
  }
};

export function isFileTooSmallError(fileSize: number) {
  const fileMinSize = 5242880;
  if (fileSize < fileMinSize) {
    return true;
  } else {
    return false;
  }
};

export function chunkSizeCalculation(fileSize: number) {

  //NB from 10 MB to 5TB

  var chunkArray = [
    10,
    50,
    100,
    150,
    200,
    500,
    750,
    1000
  ];
  var fileSizeInMb = (fileSize / (1024 * 1024));
  var optimalChunkSizeInMB = chunkArray[0];
  var fiveTBinMB = 5 * 1024 * 1024;
  var oneTBinMb = 1024 * 1024;
  var oneGBinMB = 1024;
  var tenGBinMB = 10 * 1024;
  var oneHundredGbinMB = 100 * 1024;

  if (fileSizeInMb >= 10 && fileSizeInMb < 100) {
    optimalChunkSizeInMB = chunkArray[0];
  }
  if (fileSizeInMb >= 100 && fileSizeInMb < 200) {
    optimalChunkSizeInMB = chunkArray[1];
  }
  if (fileSizeInMb >= 200 && fileSizeInMb < 500) {
    optimalChunkSizeInMB = chunkArray[2];
  }
  if (fileSizeInMb >= 500 && fileSizeInMb < oneGBinMB) {
    optimalChunkSizeInMB = chunkArray[3];
  }
  if (fileSizeInMb >= oneGBinMB && fileSizeInMb < tenGBinMB) {
    optimalChunkSizeInMB = chunkArray[4]
  }
  if (fileSizeInMb >= tenGBinMB && fileSizeInMb < oneHundredGbinMB) {
    optimalChunkSizeInMB = chunkArray[5]
  }
  if (fileSizeInMb >= oneHundredGbinMB && fileSizeInMb < oneTBinMb) {
    optimalChunkSizeInMB = chunkArray[6]
  }
  if (fileSizeInMb >= oneTBinMb && fileSizeInMb < fiveTBinMB) {
    optimalChunkSizeInMB = chunkArray[7]
  }

  var optimalChunkSizeInBytes = 1024 * 1024 * optimalChunkSizeInMB;

  return optimalChunkSizeInBytes;
};

export const initUpload = ({
  fileSize,
  s3Key,
  fileType
}: {
  fileSize: number;
  s3Key: string;
  fileType: string;
}) => {
  const res = axios({
    url: "/live/uploader/init",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      file_size: fileSize,
      s3_key: s3Key,
      file_type: fileType
    }
  }).then(function (res) {
    console.log(res);
    const data = res.data.message;
    console.log(data);
    return data;
  })
    .catch(error => {
      console.log("Error: " + error);
    });
  return res;
};

// Not in use, for reference only. Axios is used instead to support accurate upload progress.
export const continueUpload = ({
  chunk,
  presignedUrl
}: {
  chunk: any,
  presignedUrl: string
}) => {
  const data = new FormData();
  data.append('file', chunk);
  const res = fetch(presignedUrl, {
    method: 'PUT',
    body: chunk,
    headers: {}
  }).then(function (response) {
    try {
      for (let entry of response.headers.entries()) {
        // Log headers (etag..)
        console.log(entry);
      }
    } catch (e) { console.log(e); }

    console.log(response);
    const code = response.status;
    return code;
  }).catch(error => {
    console.log("Error: " + error);
  });
  return res;
};

export const continueUploadAxios = ({
  chunk,
  presignedUrl,
  config
}: {
  chunk: any,
  presignedUrl: string,
  config: any
}) => {
  const res = axios.put(
    presignedUrl,
    chunk,
    config
  ).then(function (response) {
    console.log(response);
    const code = response.status;
    return code;
  }).catch(error => {
    console.log("Error: " + error);
  });
  return res;
};
export const finalizeUpload = ({
  s3Key,
  uploadID
}: {
  s3Key: string,
  uploadID: string
}) => {
  const res = axios({
    url: "/live/uploader/finalize",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      s3_key: s3Key,
      upload_id: uploadID
    }
  }).then(function (res) {
    const data = res;
    console.log(data);
    return data;
  })
    .catch(error => {
      console.log("Error: " + error);
    });
  return res;
};

export const getPressignedUrl = ({
  s3Key,
  partNumber,
  uploadId
}: {
  s3Key: string,
  partNumber: number,
  uploadId: string
}) => {
  const res = axios({
    url: "/live/uploader/continue",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      s3_key: s3Key,
      part_number: partNumber,
      upload_id: uploadId
    }
  }).then(function (res) {
    const data = res.data.message;
    console.log(data);
    return data;
  })
    .catch(error => {
      console.log("Error: " + error);
    });
  return res;
};

export function defineChunkSizeArray(n: number, fileSize: number, optimalChunkSizeInBytes: number) {
  var res: Array<object> = [];
  var startByte: number = 0;
  var endByte: number = optimalChunkSizeInBytes - 1;
  try {
    Array.from({ length: n }, (x, i) => {
      var tmpHash = {};
      tmpHash['part'] = i + 1;
      tmpHash['startByte'] = startByte;

      if (i != (n - 1)) {
        // Normal chunk
        tmpHash['endByte'] = endByte;
      } else {
        // Final chunk
        tmpHash['endByte'] = fileSize;
      }
      res.push(tmpHash);
      startByte = endByte;
      endByte += optimalChunkSizeInBytes;
    });
  } catch (e) {
    console.log("[ERROR] " + e);
  }
  return res;
};
